import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {GithubPicker, TwitterPicker} from 'react-color';
import {projectColors} from '../constants';

class ColorsPicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showWindow: false,
		};
	}

	handleChangeComplete(color, event) {
		this.props.onColorSelect(color.hex);
	}

	handleClose() {
		this.setState({showWindow: false});
	}

	handleClick() {
		this.setState({showWindow: !this.state.showWindow});
	}

	shouldHaveBorder(hexa) {
		const code = hexa.replace('#', '');
		const r = parseInt(code.substring(0, 2), 16);
		const g = parseInt(code.substring(2, 4), 16);
		const b = parseInt(code.substring(4, 6), 16);

		const y = 0.2126 * r + 0.7152 * g + 0.0722 * b;
		return y > 240; //assume that at this point a border is necessary
	}

	render() {
		return (
			<div className="colors-picker-container" tabIndex="0">
				{this.props.rectangle ? (
					<div
						className={'color-picker rectangle' + (this.props.projectLocked ? ' locked' : '')}
						style={{backgroundColor: this.props.value, border: this.shouldHaveBorder(this.props.value) ? '1px solid #e6e6e6' : 'none'}}
						onClick={this.handleClick.bind(this)}
					></div>
				) : (
					<svg
						className={'color-picker' + (this.props.projectLocked ? ' locked' : '')}
						height={this.props.size ? this.props.size + 'px' : '36px'}
						width={this.props.size ? this.props.size + 'px' : '36px'}
						onClick={this.handleClick.bind(this)}
					>
						<circle data-cy={this.props.cy} cx={this.props.size / 2 || '16'} cy={this.props.size / 2 || '16'} r={this.props.size / 2 || '15'} style={{fill: this.props.value}} />
					</svg>
				)}

				{this.state.showWindow && !this.props.projectLocked ? (
					this.props.isOldCompany ? (
						<div className={'options-window twitter-picker '}>
							<div className="cover" onClick={this.handleClose.bind(this)} />
							<TwitterPicker color={this.props.value} triangle={'top-right'} colors={projectColors} onChangeComplete={this.handleChangeComplete.bind(this)} width={312} />
						</div>
					) : (
						<div className={'options-window github-picker'}>
							<div className="cover" onClick={this.handleClose.bind(this)} />
							<GithubPicker color={this.props.value} triangle={'top-right'} colors={projectColors} onChangeComplete={this.handleChangeComplete.bind(this)} width={162} />
						</div>
					)
				) : (
					''
				)}
			</div>
		);
	}
}

ColorsPicker.propTypes = {
	value: PropTypes.string.isRequired,
	colors: PropTypes.array.isRequired,
	onColorSelect: PropTypes.func.isRequired,
	projectLocked: PropTypes.bool,
	size: PropTypes.number,
	renderLeft: PropTypes.bool,
};

export default ColorsPicker;
